import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppActions } from '../app.actions';
export const messagesExtensionsFRResolver: ResolveFn<any> = (route, state) => {
  const store = inject(Store);
  store.dispatch(new AppActions.getMessagesExtensionsFrontReader());
};
